export const THUMB_MAX_WIDTH = 168;
export const THUMB_MAX_HEIGHT = 220;
export const THUMB_RENDER_BUFFER = 5;
export const THUMB_ITEM_MIN_HEIGHT = THUMB_MAX_HEIGHT + 28;

export const getThumbnailViewport = (page: any) => {
  const baseViewport = page.getViewport({ scale: 1 });
  const scale = Math.min(
    THUMB_MAX_WIDTH / Math.max(baseViewport.width, 1),
    THUMB_MAX_HEIGHT / Math.max(baseViewport.height, 1)
  );
  return page.getViewport({ scale });
};

export const renderPdfThumbnailToCanvas = async (
  pdfDoc: any,
  pageNo: number,
  canvas: HTMLCanvasElement,
  isCancelled: () => boolean
) => {
  const page = await pdfDoc.getPage(pageNo);
  if (isCancelled()) return false;

  const viewport = getThumbnailViewport(page);
  const context = canvas.getContext("2d");
  if (!context) return false;

  canvas.width = Math.floor(viewport.width);
  canvas.height = Math.floor(viewport.height);
  canvas.style.width = `${viewport.width}px`;
  canvas.style.height = `${viewport.height}px`;
  context.setTransform(1, 0, 0, 1, 0, 0);
  await page.render({ canvasContext: context, viewport }).promise;
  return !isCancelled();
};

export const orderThumbnailPages = (pageNumbers: number[], priorityPage?: number) => {
  const uniquePages = Array.from(new Set(pageNumbers)).filter((pageNo) => pageNo > 0);
  if (!uniquePages.length) return [];

  const min = Math.min(...uniquePages);
  const max = Math.max(...uniquePages);
  const ordered: number[] = [];

  if (priorityPage != null && priorityPage >= min && priorityPage <= max) {
    ordered.push(priorityPage);
  }
  for (let pageNo = min; pageNo <= max; pageNo += 1) {
    if (pageNo !== priorityPage && uniquePages.includes(pageNo)) {
      ordered.push(pageNo);
    }
  }
  for (const pageNo of uniquePages) {
    if (pageNo < min || pageNo > max) {
      ordered.push(pageNo);
    }
  }
  return ordered;
};

export const getThumbnailNeighborPages = (
  currentPage: number,
  totalPages: number,
  buffer = THUMB_RENDER_BUFFER
) => {
  const first = Math.max(1, currentPage - buffer);
  const last = Math.min(totalPages, currentPage + buffer);
  return Array.from({ length: last - first + 1 }, (_, index) => first + index);
};
